module.exports = __webpack_public_path__ + "img/Traiteur.74c98bf1.jpg";